// @ts-nocheck
import clsx from 'clsx'
import {FC} from 'react'
import {Row} from 'react-table'
import {Company} from '../../core/_models'
import {Link} from 'react-router-dom'

type Props = {
  row: Row<Company>
}

const CustomRow: FC<Props> = ({row, companyId}) => (
  // <Link to='/crafted/pages/profile/campaigns'>
  <tr {...row.getRowProps()}>
    {row.cells.map((cell) => {
      return (
        <td
          {...cell.getCellProps()}
          className={clsx({'text-end min-w-100px': cell.column.id === 'actions'})}
        >
          {cell.render('Cell')}
        </td>
      )
    })}
  </tr>
  // </Link>
)

export {CustomRow}
